import { render, staticRenderFns } from "./65qyvideo.vue?vue&type=template&id=78ec1e60&"
import script from "./65qyvideo.vue?vue&type=script&lang=js&"
export * from "./65qyvideo.vue?vue&type=script&lang=js&"
import style0 from "./65qyvideo.vue?vue&type=style&index=0&id=78ec1e60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports